var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "c-table-cell" },
    [
      _vm.cell === "employee"
        ? _c(
            "div",
            { staticClass: "c-table-cell__wrapper cell-employee" },
            [
              _c(
                "router-link",
                {
                  staticClass: "cell-employee__name",
                  attrs: {
                    to: {
                      name: "personal-employee-summary",
                      params: { id: _vm.data.id },
                    },
                  },
                },
                [_vm._v(" " + _vm._s(_vm.data.fullName) + " ")]
              ),
              _c("div", { staticClass: "cell-employee__info" }, [
                _vm.data.docsTrouble
                  ? _c(
                      "div",
                      {
                        staticClass: "cell-employee__docs-trouble",
                        on: {
                          click: function ($event) {
                            return _vm.$router.push({
                              name: "personal-employee-summary",
                              params: { id: _vm.data.id },
                            })
                          },
                        },
                      },
                      [
                        _c(
                          "svg",
                          {
                            attrs: {
                              width: "10",
                              height: "13",
                              viewBox: "0 0 10 13",
                              fill: "none",
                              xmlns: "http://www.w3.org/2000/svg",
                            },
                          },
                          [
                            _c("path", {
                              attrs: {
                                d: "M6.96875 1H1V12H9V3.03125M6.96875 1L9 3.03125M6.96875 1V3.03125H9M3 6C3 6 5.4379 6 7 6M3 9.03125C3 9.03125 5.4379 9.03125 7 9.03125",
                                stroke: "#FF238D",
                                "stroke-width": "2",
                              },
                            }),
                          ]
                        ),
                        _c(
                          "div",
                          {
                            staticClass: "cell-employee__docs-trouble-tooltip",
                          },
                          [_vm._v(" " + _vm._s(_vm.data.docsTrouble) + " ")]
                        ),
                      ]
                    )
                  : _vm._e(),
                _vm.data.rankStatus
                  ? _c(
                      "div",
                      {
                        staticClass: "cell-employee__rank-status",
                        class: `cell-employee__rank-status_${_vm.data.rankStatus}`,
                      },
                      [
                        _c(
                          "svg",
                          {
                            attrs: {
                              width: "10",
                              height: "12",
                              viewBox: "0 0 10 12",
                              xmlns: "http://www.w3.org/2000/svg",
                            },
                          },
                          [
                            _c("path", {
                              attrs: {
                                d: "M5 1V11M5 11L9 7M5 11L1 7",
                                "stroke-width": "2",
                                "stroke-linecap": "round",
                                "stroke-linejoin": "round",
                              },
                            }),
                          ]
                        ),
                        _c(
                          "div",
                          { staticClass: "cell-employee__rank-status-tooltip" },
                          [
                            _vm._v(
                              " " + _vm._s(_vm.rankStatusRecommendation) + " "
                            ),
                          ]
                        ),
                      ]
                    )
                  : _vm._e(),
              ]),
            ],
            1
          )
        : _vm._e(),
      _vm.cell === "deposit-state"
        ? _c(
            "div",
            {
              staticClass: "c-table-cell__wrapper cell-deposit-state",
              class: `cell-deposit-state_${_vm.data.color}`,
            },
            [
              _c("div", { staticClass: "cell-deposit-state__label" }, [
                _vm._v(_vm._s(_vm.data.text)),
              ]),
            ]
          )
        : _vm._e(),
      _c(_vm.cellComponent, { tag: "component", attrs: { data: _vm.data } }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }